import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config';
import Header from '../components/Header';
import { getWorkshops } from '../data/homeData';
import SEO from '../components/SEO';
import './Events.css';

const Events = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 获取隐私链接
  const getPrivacyLink = async (imageUrl) => {
    try {
      const response = await fetch(`${BASE_URL}/privacy_link?img_url=${encodeURIComponent(imageUrl)}`);
      const data = await response.json();
      if (typeof data === 'string') {
        return data; // 直接返回URL字符串
      }
      return data.link || data; // 返回link字段或整个响应
    } catch (error) {
      console.error('Error fetching privacy link:', error);
      return imageUrl; // 如果获取失败，返回原始URL
    }
  };

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const data = await getWorkshops();
        // 处理活动数据
        const processedEvents = await Promise.all(
          data.map(async (event) => {
            const privacyLink = await getPrivacyLink(event.image);
            return {
              ...event,
              privacyImage: privacyLink
            };
          })
        );
        setEvents(processedEvents);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  if (loading) {
    return <div className="loading">加载中...</div>;
  }

  if (error) {
    return <div className="error">加载失败: {error}</div>;
  }

  return (
    <div className="events-container">
      <SEO page="events" />
      <div className="page-container">
        <Header />
        <main className="main-content full-width">
          <h1 className="page-title">精彩活动</h1>
          <div className="event-list">
            {events.map(event => (
              <div key={event.id} className="event-card">
                <img
                  src={event.privacyImage || '/images/default-img-cover.png'}
                  alt={event.title}
                  className="event-image"
                  width="400"
                  height="200"
                  loading="lazy"
                  onError={(e) => {
                    e.target.onerror = null; 
                    e.target.src = '/images/default-img-cover.png';
                  }}
                />
                <div className="event-info">
                  <h3 className="event-title">{event.title}</h3>
                  <div className="event-meta">
                    <span className="event-date">{event.date}</span>
                    <span className="event-time">{event.time}</span>
                    <span className="event-location">{event.location}</span>
                  </div>
                  <p className="event-description">{event.description}</p>
                  <button className="event-button" onClick={() => window.location.href=`/registration`}>立即报名</button>
                </div>
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Events;
